  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
//import TagManager                                          from 'react-gtm-module'
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_BillsService }                                 from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
  //------
  // Style
  //------
  import TransferOnline4bStyle                               from "./TransferOnline4bStyle.jsx";
  //-------
  // images
  //-------
//import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import bank1                                               from "assets/img/wu/banks_alpha.png";
  import bank2                                               from "assets/img/wu/banks_eurobank.png";
  import bank3                                               from "assets/img/wu/banks_nbg.png";
  import bank4                                               from "assets/img/wu/banks_piraeus.png";
  //----------
  // variables
  //----------
  const filename = "TransferOnline4b ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

class TransferOnline4b extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    let UserSelectedCountry = localStorage.getItem("UserSelectedCountry") ? localStorage.getItem("UserSelectedCountry") : "GR";
    UserSelectedCountry     = UserSelectedCountry.toUpperCase();
    let greece_tfd_isHidden = (UserSelectedCountry==="GR") ? false : true;
    let sepa_tfd_isHidden   = (UserSelectedCountry==="GR") ? true  : false;

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      viewPleaseWait_hidden                                : true,

      //popup gotoStep2
      dialog_gotoStep2_msg                                   : "",
      dialog_gotoStep2_isOpen                                : false,

      greece_tfd_isHidden                                  : greece_tfd_isHidden,
      greece_tfd_amountdue                                 : "",
      greece_tfd_bankpaycode                               : "",
      greece_tfd_senderFirstLastName                       : "",

      sepa_tfd_isHidden                                    : sepa_tfd_isHidden,
      sepa_tfd_bankpaycode                                 : "",
      sepa_tfd_amountdue                                   : "",
      sepa_tfd_iban                                        : "GR84848482340032494392349432",
      sepa_tfd_bic                                         : "89342890234890",
      sepa_tfd_beneficiaryname                             : "Worldbridge Payment Institution",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                 = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                = this.dialog_handleClose.bind(this);
    this.startSpinners                                     = this.startSpinners.bind(this);
    this.stopSpinners                                      = this.stopSpinners.bind(this);

    this.makeScreenTranslations                            = this.makeScreenTranslations.bind(this);

    this.btn_gotoTransferHome_act                          = this.btn_gotoTransferHome_act.bind(this);
    this.btn_bank1_act                                     = this.btn_bank1_act.bind(this);
    this.btn_bank2_act                                     = this.btn_bank2_act.bind(this);
    this.btn_bank3_act                                     = this.btn_bank3_act.bind(this);
    this.btn_bank4_act                                     = this.btn_bank4_act.bind(this);

    //popup gotoStep2
    this.dialog_gotoStep2_handleOpen                                  = this.dialog_gotoStep2_handleOpen.bind(this);
    this.dialog_gotoStep2_btn_bills                                   = this.dialog_gotoStep2_btn_bills.bind(this);
    this.dialog_gotoStep2_btn_home                                    = this.dialog_gotoStep2_btn_home.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      //++++++++++++
      //Login Screen
      //++++++++++++
      wu_Utilities.LogoutUserFromApp(filename);
      history.push(wu_Utilities.getNavigationURLs("LoginPage"));
      return;
    }

    //------------------
    //Repeat Transaction
    //------------------
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}

    this.makeScreenTranslations();
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container}>
        {this.state.greece_tfd_isHidden === true ? ( "" ) : (
          <GridContainer justify="center">
            <GridItem xs={12} sm={6} md={6}>
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline4b_label0}>{this.NSInforString("TransferOnline4b_label0")}</div>
                  </GridItem>
                </GridContainer>
              </div>

              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline4b_label1}>{this.NSInforString("TransferOnline4b_label1a")}<span><b>{this.NSInforString("TransferOnline4b_label1b")}</b></span></div>
                  </GridItem>
                </GridContainer>
              </div>

              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      id="standard-read-only-input3"
                      label={this.NSInforString("TransferOnline4b_plh03")}
                      value={this.state.greece_tfd_senderFirstLastName}
                      InputProps={{ fullWidth:true, readOnly:true}}
                    />
                  </GridItem>
                </GridContainer>
              </div>

              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      id="standard-read-only-input1"
                      label={this.NSInforString("TransferOnline4b_plh01")}
                      value={this.state.greece_tfd_bankpaycode}
                      InputProps={{ fullWidth:true, readOnly:true}}
                    />
                  </GridItem>
                </GridContainer>
              </div>

              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      id="standard-read-only-input2"
                      label={this.NSInforString("TransferOnline4b_plh02")}
                      value={this.state.greece_tfd_amountdue}
                      InputProps={{ fullWidth:true, readOnly:true}}
                    />
                  </GridItem>
                </GridContainer>
              </div>

              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={3} sm={3} md={3}><Button onClick={this.btn_bank1_act}><img width="63px" height="63px" src={bank1} alt=""/></Button></GridItem>
                  <GridItem xs={3} sm={3} md={3}><Button onClick={this.btn_bank2_act}><img width="63px" height="63px" src={bank2} alt=""/></Button></GridItem>
                  <GridItem xs={3} sm={3} md={3}><Button onClick={this.btn_bank3_act}><img width="63px" height="63px" src={bank3} alt=""/></Button></GridItem>
                  <GridItem xs={3} sm={3} md={3}><Button onClick={this.btn_bank4_act}><img width="63px" height="63px" src={bank4} alt=""/></Button></GridItem>
                </GridContainer>
              </div>

              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline4b_label2}>{this.NSInforString("TransferOnline4b_label2")}</div>
                  </GridItem>
                </GridContainer>
              </div>
              {/* ------------------------- */}
              {/* ----------[SPINNERS]----- */}
              {/* ------------------------- */}
              {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                  <GridItem xs={6} sm={6} md={6}>
                    <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                  </GridItem>
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                </GridContainer>
              )}
              {/* ------------------------- */}
              {/* ----------[BUTTONS]------ */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    <div className={classes.textCenter}>
                      <CustomButton
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.btn_gotoTransferHome_act}
                        type="submit">
                        {this.NSInforString("TransferOnline4b_btn_gotoTransferHome")}
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              </div>

            </GridItem>
          </GridContainer>
        )}
        {this.state.sepa_tfd_isHidden === true ? ( "" ) : (
          <GridContainer justify="center">
            <GridItem xs={12} sm={6} md={6}>

              {/* ------------------------- */}
              {/* ----------[label]-------- */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline4b_sepa_bold}>{this.NSInforString("TransferOnline4b_sepa_ts")}</div>
                  </GridItem>
                </GridContainer>
              </div>
              {/* ------------------------- */}
              {/* ----------[label]-------- */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline4b_sepa_normal}>{this.NSInforString("TransferOnline4b_sepa_lbl1")}</div>
                  </GridItem>
                </GridContainer>
              </div>
              {/* ------------------------- */}
              {/* ----------[textfield]---- */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      id="standard-read-only-input2"
                      label={this.NSInforString("TransferOnline4b_sepa_IBAN")}
                      value={this.state.sepa_tfd_iban}
                      InputProps={{ fullWidth:true, readOnly:true}}
                    />
                  </GridItem>
                </GridContainer>
              </div>
              {/* ------------------------- */}
              {/* ----------[textfield]---- */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      id="standard-read-only-input2"
                      label={this.NSInforString("TransferOnline4b_sepa_BIC")}
                      value={this.state.sepa_tfd_bic}
                      InputProps={{ fullWidth:true, readOnly:true}}
                    />
                  </GridItem>
                </GridContainer>
              </div>
              {/* ------------------------- */}
              {/* ----------[textfield]---- */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      id="standard-read-only-input2"
                      label={this.NSInforString("TransferOnline4b_sepa_beneficiaryName")}
                      value={this.state.sepa_tfd_beneficiaryname}
                      InputProps={{ fullWidth:true, readOnly:true}}
                    />
                  </GridItem>
                </GridContainer>
              </div>
              {/* ------------------------- */}
              {/* ----------[textfield]---- */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      id="standard-read-only-input2"
                      label={this.NSInforString("TransferOnline4b_sepa_amountDue")}
                      value={this.state.sepa_tfd_amountdue}
                      InputProps={{ fullWidth:true, readOnly:true}}
                    />
                  </GridItem>
                </GridContainer>
              </div>
              {/* ------------------------- */}
              {/* ----------[textfield]---- */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      id="standard-read-only-input2"
                      label={this.NSInforString("TransferOnline4b_sepa_bankpaycode")}
                      value={this.state.sepa_tfd_bankpaycode}
                      InputProps={{ fullWidth:true, readOnly:true}}
                    />
                  </GridItem>
                </GridContainer>
              </div>
              {/* ------------------------- */}
              {/* ----------[label]-------- */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline4b_sepa_normal}>{this.NSInforString("TransferOnline4b_sepa_lbl3")}</div>
                  </GridItem>
                </GridContainer>
              </div>
              {/* ------------------------- */}
              {/* ----------[label]-------- */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline4b_sepa_normal}>{this.NSInforString("TransferOnline4b_sepa_lbl4")}</div>
                  </GridItem>
                </GridContainer>
              </div>
              {/* ------------------------- */}
              {/* ----------[label]-------- */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline4b_sepa_normal}>{this.NSInforString("TransferOnline4b_sepa_lbl5")}</div>
                  </GridItem>
                </GridContainer>
              </div>
              {/* ------------------------- */}
              {/* ----------[SPINNERS]----- */}
              {/* ------------------------- */}
              {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                  <GridItem xs={6} sm={6} md={6}>
                    <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                  </GridItem>
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                </GridContainer>
              )}
              {/* ------------------------- */}
              {/* ----------[BUTTONS]------ */}
              {/* ------------------------- */}
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    <div className={classes.textCenter}>
                      <CustomButton
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.btn_gotoTransferHome_act}
                        type="submit">
                        {this.NSInforString("TransferOnline4b_btn_gotoTransferHome")}
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              </div>
            </GridItem>
          </GridContainer>
        )}
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------------------- */}
        {/* ----------[POPUP gotoStep2]------------- */}
        {/* ---------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_gotoStep2_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_gotoStep2_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_gotoStep2_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_gotoStep2} color="default" onClick={this.dialog_gotoStep2_btn_bills}>{this.NSInforString("TransferOnline4b_alert_btn_bills")}</Button>
              <Button className={classes.popupOkButton_gotoStep2} color="default" onClick={this.dialog_gotoStep2_btn_home}>{this.NSInforString("TransferOnline4b_alert_btn_home")}</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  makeScreenTranslations(){
      let methName = filename+"makeScreenTranslations ";
      //if(api.print_logs){console.log(methName);}

      let parserObject_finalizeoutbound = {};
      let parserObject_validatecustomer = {};
      try { parserObject_finalizeoutbound = JSON.parse(localStorage.getItem("parserObject_finalizeoutbound")); }catch(err){;}
      try { parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer")); }catch(err){;}

      let iban  = "";
      let bic   = "";
      let mtcn  = "";
      let gross = 0.0; //float
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let parserObject_validateoutbound_d2b = {};
          try { parserObject_validateoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_validateoutbound_d2b")); }catch(err){;}
          try {iban  = parserObject_finalizeoutbound["iban"];      }catch(err){;} if(iban  === null || (typeof iban ==="undefined")){iban  = " - ";}
          try {bic   = parserObject_finalizeoutbound["bic"];       }catch(err){;} if(bic   === null || (typeof bic  ==="undefined")){bic   = " - ";}
          try {mtcn  = parserObject_finalizeoutbound["mtcn"];      }catch(err){;} if(mtcn  === null || (typeof mtcn ==="undefined")){mtcn  = " - ";}
          try {gross = parserObject_validateoutbound_d2b["gross"]; }catch(err){;} if(gross === null || (typeof gross==="undefined")){gross = 0.0;  }
      }
      else{
          let parserObject_validateoutbound = {};
          try { parserObject_validateoutbound = JSON.parse(localStorage.getItem("parserObject_validateoutbound")); }catch(err){;}
          try {iban  = parserObject_finalizeoutbound["iban"];  }catch(err){;} if(iban  === null || (typeof iban ==="undefined")){iban  = " - ";}
          try {bic   = parserObject_finalizeoutbound["bic"];   }catch(err){;} if(bic   === null || (typeof bic  ==="undefined")){bic   = " - ";}
          try {mtcn  = parserObject_finalizeoutbound["mtcn"];  }catch(err){;} if(mtcn  === null || (typeof mtcn ==="undefined")){mtcn  = " - ";}
          try {gross = parserObject_validateoutbound["gross"]; }catch(err){;} if(gross === null || (typeof gross==="undefined")){gross = 0.0;  }
      }
      //-----------------------------------
      //countryResidence,firstName,lastName
      //-----------------------------------
      let countryResidence = "";
      let fname            = "";
      let lname            = "";
      try {countryResidence = parserObject_validatecustomer["countryResidence"]; }catch(err){;} if(countryResidence === null){countryResidence = "";}
      try {fname            = parserObject_validatecustomer["fname"];            }catch(err){;} if(fname            === null){fname            = "";}
      try {lname            = parserObject_validatecustomer["lname"];            }catch(err){;} if(lname            === null){lname            = "";}
      //-------------------
      //UserSelectedCountry
      //-------------------
      let UserSelectedCountry = localStorage.getItem("UserSelectedCountry") ? localStorage.getItem("UserSelectedCountry") : "GR";

      if(api.print_logs){console.log(methName+"mainDelegate.appLang = "+localStorage.getItem("lang"));}
      if(api.print_logs){console.log(methName+"countryResidence     = "+countryResidence);}
      if(api.print_logs){console.log(methName+"UserSelectedCountry  = "+UserSelectedCountry);}

    //let countryCriteria = [countryResidence uppercaseString];
    //let countryCriteria = UserSelectedCountry.toUpperCase();

      this.setState({
        "greece_tfd_bankpaycode"         : mtcn,
        "greece_tfd_amountdue"           : this.comvert2ProperAmountFormat(gross.toFixed(2)),
        "greece_tfd_senderFirstLastName" : fname+" "+lname,

        "sepa_tfd_bankpaycode"           : mtcn,
        "sepa_tfd_amountdue"             : this.comvert2ProperAmountFormat(gross.toFixed(2)),
        "sepa_tfd_iban"                  : "GR84848482340032494392349432",
        "sepa_tfd_bic"                   : "89342890234890",
        "sepa_tfd_beneficiaryname"       : "Worldbridge Payment Institution",
      });
      //----------------------------
      //Clear TransferOnline1 Screen
      //----------------------------
      //mainDelegate.parserObject_transhistorydetail_unique = nil;
      //-------------------
      //Tag Event Recording
      //-------------------
      let shouldUseTagManager = false;//api.shouldUseTagManager;
      if(shouldUseTagManager===true){
        let centralID       = this.get_centralID();       //
        let snd_curr        = 'EUR';                      //
      //let rcv_curr        = this.get_rcv_curr();        //
        let dest_ctry_wu_id = this.get_dest_ctry_wu_id(); //GR,AL
        let gross           = this.get_gross();           //
        let paymentType     = 'banktransfer';             //'banktransfer', 'paybycard'
        let transferMethod  = (localStorage.getItem("TransferOnline1_TransferMethod")===api.TransferOnline1_TransferMethod_Cash) ? "cash" : "d2b";
        let brand           = '';//(localStorage.getItem("TransferOnline1_TransferMethod")===api.TransferOnline1_TransferMethod_Cash) ? "Store Pick Up" : "APN-D2B";

        let tagManagerData = {
          'event' : 'purchase',
          'ecommerce': {
            'currencyCode': snd_curr,           //'EUR', // αναλογα με το νομισμα  εκτός αν μετατρέπονται ολα σε eur
            'purchase' : {
              'actionField': {
                'id'          : centralID,      // Transaction ID. Required for purchases and refunds.  ο αριθμός συναλλαγής όχι ο κωδικός πληρωμής του πελάτη
                'affiliation' : paymentType,    // προτείνουμε να παίρνει τιμές paybycard/banktransfer ανάλογα με το τι εχει επιλέξει ο κάθε πελατης
                'revenue'     : gross,          // Total transaction value (incl. tax and shipping). Ανάλογα με το νόμισμα εκτός αν τα μετατρέπετε ολα σε eur οπότε αντίστοιχα
                'tax'         : '',             // σε περίπτωση που εχουν νόημα τα πεδία αυτα
                'shipping'    : '',             // σε περίπτωση που έχουν νόημα τα πεδια αυτά, Πχ Προμήθεια συναλλαγής
                'coupon'      : '',             // σε περίπτωση που εχουν νόημα τα πεδια αυτα
              },
              'products' : [{                   // List of productFieldObjects.
                'name'     : paymentType,       // Name or ID is required., προτείνουμε να παίρνει τιμές paybycard/banktransfer ανάλογα με το τι εχει επιλέξει ο κάθε πελατης
                'id'       : mtcn,              // προτείνουμε να παίρνει τιμές τον κωδικό πληρωμής όταν μιλάμε για μεταφορα μεσω τραπεζας ή ένα σταθερό id όταν μιλάμε για πληρωμή μέσω κάρτας
                'price'    : gross,             //
                'brand'    : brand,             //(25/03/2021)σε περίπτωση που έχει νόημα το πεδιο αυτό μπορούμε να το χρησιμοποιήσουμε για έξτρα πληροφορίες
                'category' : dest_ctry_wu_id,   //χωρα που παει το έμβασμα,
                'variant'  : transferMethod,    //[cash/d2b]
                'quantity' : 1,
              }],
            }
          }
        };
        //TagManager.dataLayer(tagManagerData);
        try { window.dataLayer.push(tagManagerData);                }catch(err1){console.log(methName+"err1="+err1);}
        try { console.log(methName+JSON.stringify(tagManagerData)); }catch(err2){console.log(methName+"err2="+err2);}
      }
      //----------------------
      //Criteo Event Recording
      //----------------------
      let shouldUseCriteo = false;//api.shouldUseCriteo;
      if(shouldUseCriteo===true && api.webappENV==="PROD"){
        try {
          let email           = localStorage.getItem("HTTP_user");
          let centralID       = this.get_centralID();       //
        //let gross           = this.get_gross();           //
          window.criteo_q = window.criteo_q || [];
          var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
          window.criteo_q.push(
           { event: "setAccount", account: api.criteo_account }, // You should never update this line
           { event: "setEmail", email: email },                  // Can be an empty string
           { event: "setSiteType", type: deviceType},
           { event: "trackTransaction", id: centralID, item: [{id:"1", price:1, quantity:1}] }
          );
        }catch(err0){console.log(methName+"err0="+err0);}
      }
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  get_centralID(){
    let centralID = "";
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_sendoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b"));
        centralID = parserObject_sendoutbound_d2b["centralID"]; if(centralID===null){centralID = "";}
    }
    else{
        let parserObject_sendoutbound     = JSON.parse(localStorage.getItem("parserObject_sendoutbound"));
        centralID = parserObject_sendoutbound["centralID"];     if(centralID===null){centralID = "";}
    }
    if(centralID === null || (typeof centralID ==="undefined")){ return ""; }
    return centralID;
  }
  get_rcv_curr(){
    let rcv_curr   = "";
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_sendoutbound_d2b_req = {};
        try { parserObject_sendoutbound_d2b_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b_req")); }catch(err){;}
        try {rcv_curr  = parserObject_sendoutbound_d2b_req["rcv_curr"];  }catch(err){;} if(rcv_curr === null || (typeof rcv_curr==="undefined")){rcv_curr = "";}
    }
    else{
        let parserObject_sendoutbound_req = {};
        try { parserObject_sendoutbound_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_req")); }catch(err){;}
        try {rcv_curr  = parserObject_sendoutbound_req["rcv_curr"];  }catch(err){;} if(rcv_curr === null || (typeof rcv_curr==="undefined")){rcv_curr = "";}
    }
    if(rcv_curr === null || (typeof rcv_curr ==="undefined")){ return ""; }
    return rcv_curr;
  }
  get_gross(){
    let methName = filename+"get_gross ";
    //if(api.print_logs){console.log(methName);}

    let gross = 0.0;
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_validateoutbound_d2b = {};
        try { parserObject_validateoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_validateoutbound_d2b")); }catch(err1){ console.log(methName+'err1='+err1); }
        try {gross = parserObject_validateoutbound_d2b["gross"]; }catch(err2){ console.log(methName+'err2='+err2); }
    }
    else{
        let parserObject_validateoutbound = {};
        try { parserObject_validateoutbound = JSON.parse(localStorage.getItem("parserObject_validateoutbound")); }catch(err3){ console.log(methName+'err3='+err3); }
        try {gross = parserObject_validateoutbound["gross"]; }catch(err4){ console.log(methName+'err4='+err4); }
    }
    if(gross === null || (typeof gross ==="undefined")){ return ""; }
    return gross.toFixed(2);
  }
  get_dest_ctry_wu_id(){
    let destCountryDescription = localStorage.getItem("TransferOnline1_selCountry_ctry_wu_id");
    return destCountryDescription;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_gotoTransferHome_act_OLD(event) {
    let methName = filename+"btn_gotoTransferHome_act ";
    if(api.print_logs){console.log(methName);}

    //+++++++++++++++
    //TransferOnline1
    //+++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("TransferOnline1"));
  }
  //----------------------------------------------------------------------------------------------------
  btn_gotoTransferHome_act(event) {
    let methName = filename+"btn_gotoTransferHome_act ";
    if(api.print_logs){console.log(methName);}

    let parserObject_showPopUpService_req = {};

    this.startSpinners();
    setTimeout(function() { //Start the timer
      //-------------------
      //wu_showPopUpService
      //-------------------
      wu_ProfileService
      .wu_showPopUpService(parserObject_showPopUpService_req)
      .then(res => {
        this.stopSpinners();
        var noBP = "false";
        if(res.events && res.events.length > 0){
          for(var i=0; i<res.events.length; ++i){
            var aItem = res.events[i];
            if(aItem["noBP"]===true){noBP = "true";break;}
          }
        }

        if(noBP==="true"){
          this.dialog_gotoStep2_handleOpen(this.NSInforString("TransferOnline4b_alert_msg"));
        }
        else{
          //+++++++++++++++
          //TransferOnline1
          //+++++++++++++++
          history.push(wu_Utilities.getNavigationURLs("TransferOnline1"));
          return;
        }
      })
      .catch(err => {
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err)+" err="+err);
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  btn_bank1_act(event) {
    let methName = filename+"btn_bank1_act ";
    if(api.print_logs){console.log(methName);}
    window.open("https://www.alpha.gr", "_blank") //to open new page
  }
  //----------------------------------------------------------------------------------------------------
  btn_bank2_act(event) {
    let methName = filename+"btn_bank2_act ";
    if(api.print_logs){console.log(methName);}
    window.open("https://ebanking.eurobank.gr", "_blank") //to open new page
  }
  //----------------------------------------------------------------------------------------------------
  btn_bank3_act(event) {
    let methName = filename+"btn_bank3_act ";
    if(api.print_logs){console.log(methName);}
    window.open("https://www.nbg.gr/", "_blank") //to open new page
  }
  //----------------------------------------------------------------------------------------------------
  btn_bank4_act(event) {
    let methName = filename+"btn_bank4_act ";
    if(api.print_logs){console.log(methName);}
    window.open("https://www.piraeusbank.gr/", "_blank") //to open new page
  }
  //
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateName, stateVar) {
    if(api.print_logs){console.log(stateName+" "+stateVar+" "+event.target.value);}
    this.setState({ [stateVar] : event.target.value });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email"){ return wu_Utilities.wu_verifyEmail(val); }
    if(key==="MTCN") { return wu_Utilities.wu_verifyMTCN(val);  }

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  comvert2ProperAmountFormat(amountStr){
    try{
      let parts = amountStr.split('.');
      let part1 = this.numberWithCommas(parts[0]);
      let part2 = parts[1];
      return part1+","+part2;
    }catch(err){;}
    return amountStr;
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups gotoStep2----------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_gotoStep2_handleOpen(dialog_msg){
    setTimeout(function() {
      this.setState({
        "dialog_gotoStep2_isOpen" : true,
        "dialog_gotoStep2_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_gotoStep2_btn_bills(){
    let methName = filename+"dialog_gotoStep2_btn_bills ";
    if(api.print_logs){console.log(methName);}

    //+++++
    //Bills
    //+++++
    history.push(wu_Utilities.getNavigationURLs("Bills"));
  }
  //----------------------------------------------------------------------------------------------------
  dialog_gotoStep2_btn_home(){
    let methName = filename+"dialog_gotoStep2_btn_home ";
    if(api.print_logs){console.log(methName);}

    //+++++++++++++++
    //TransferOnline1
    //+++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("TransferOnline1"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
}
TransferOnline4b.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(TransferOnline4bStyle)(TransferOnline4b)
);
